<mat-progress-bar *ngIf="chargement" mode="indeterminate"></mat-progress-bar>
<div style="width: 100%">
  <div class="displayFlex">     
      <div *ngFor="let btn of listBtn" class="button-row">
          <button *ngIf="!btn.disabled" [disabled]="btn.disabled" [name]="btn.name" (click)="clickBtnHeat(btn.name)" mat-raised-button [ngClass]="btn.class"><mat-icon *ngIf="btn.icon != undefined && btn.icon != null">{{btn.icon}}</mat-icon>{{btn.text}}</button>
      </div>
  </div>
  <div [ngStyle]="styleTab"  class="example-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" [matSortDisabled]="matSortDisabled" matSort>
      <ng-container *ngFor="let column of displayedColumnsBrut.TableRD" matColumnDef="{{column.TableRD_Champs}}">
       <!-- <ng-container *ngIf="!column.TableRD_MiltipleSelect"> -->
        <th [ngStyle]="getStyle(column)" mat-header-cell *matHeaderCellDef >
          <table style="width: 100%" >
            <tr >
              <td [ngStyle]="getStyle(column)" >
                <mat-label *ngIf="showFilter">{{column.TableRD_Des}}</mat-label>  
                <input *ngIf="showFilter" class="recherche-input"  matInput [ngClass]="'inputSearch'+randomNumber" (keyup)="onkeyup()" [name]="column.TableRD_Champs">
                <span *ngIf="!showFilter" mat-sort-header>{{column.TableRD_Des}}</span>
              </td>
              <td style="width: 20%" *ngIf="showFilter" mat-sort-header></td>
            </tr>
          </table>                                       
        </th>
        
        <td (click)="clickColumn($event,i)" [ngStyle]="getStyle(column)" mat-cell *matCellDef="let row; let i = index">
<!-- column read_Only -->
            <div *ngIf="column.TableRD_ReadOnly || displayedColumnsBrut.read_Only;else col"  >
                
              <!-- text TableRD_Type = 0 -->
              <span *ngIf="column.TableRD_Type==0" >{{row[column.TableRD_Champs]}}</span>
              
              <!-- checkbox box TableRD_Type = 1 -->
              <span *ngIf="column.TableRD_Type==1">
                  <mat-checkbox [name]="'input_'+column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]"></mat-checkbox>
              </span>
              <div *ngIf="column.TableRD_Type==2">
                <mat-form-field    [ngStyle]="getStyleInput(column)"  appearance="outline">
                  <mat-select [disabled]="true" [name]="'select_'+column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]">
                    <mat-option *ngFor="let select of column.dataSelect" [value]="getValueSelect(select,column)">
                      {{getTextSelect(select,column)}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- date TableRD_Type = 4 -->
              <span *ngIf="column.TableRD_Type==4" >
                  {{row[column.TableRD_Champs]  | date: column.TableRD_Format}}
              </span>
              <!-- image TableRD_Type = 5 -->
              <span *ngIf="column.TableRD_Type==5" >
                  <img [src]="row[column.TableRD_Champs]">
              </span>
              <!-- number TableRD_Type = 6 -->
              <span *ngIf="column.TableRD_Type==6"  >
                <span > {{row[column.TableRD_Champs]  | number:column.TableRD_Format}}</span>
              </span>
              <!-- html TableRD_Type = 7 -->
              <div *ngIf="column.TableRD_Type==7"  [innerHTML]="sanitizer.bypassSecurityTrustHtml(row[column.TableRD_Champs])"></div>
              
              <!-- icon material TableRD_Type = 8 -->
              <span *ngIf="column.TableRD_Type==8"  >
                <mat-icon color="primary">{{row[column.TableRD_Champs]}}</mat-icon>
              </span>
               <!-- time TableRD_Type = 9 -->
               <span *ngIf="column.TableRD_Type==9" >
                  {{getNewDate(row[column.TableRD_Champs] ) | date: column.TableRD_Format}}
              </span>
              <!-- button TableRD_Type = 100 -->
              <span *ngIf="column.TableRD_Type==100" class="button-row">
                <button type="button"  mat-raised-button color="primary" (click)="clickBtnTable(row,column.TableRD_Champs,i)">
                  <mat-icon>{{column.TableRD_Icon}}</mat-icon>
                  <span>{{row[column.TableRD_Champs] }}</span>
                </button>
              </span>
              <!-- Link TableRD_Type = 101 -->
              <span *ngIf="column.TableRD_Type==101">
                  <a *ngIf="!isPopap(row,column)" routerLink="{{getHref(row,column)}}">{{row[column.TableRD_Champs] }} </a>           
                  <a *ngIf="isPopap(row,column)" style="cursor: pointer;color: #1a0dab;text-decoration: underline" (click)="popupCenter(row,column)" >{{row[column.TableRD_Champs] }} </a>           
              </span> 
            </div> 
<!--  column editable -->           
            <ng-template  #col>
              <!-- text box TableRD_Type = 0 -->
              <div *ngIf="column.TableRD_Type==0">
                  <mat-form-field   appearance="outline"  [ngStyle]="getStyleInput(column)" >
                      <input 
                      [ngStyle]="getStyleInput(column)"
                      matInput 
                      [disabled]="getDisabled(row,column)"
                      [type]="column.TableRD_Param2" 
                      [name]="'input_'+column.TableRD_Champs" 
                      [(ngModel)]="row[column.TableRD_Champs]" 
                      (input)="onInput($event,row,column,i)"  
                      (keydown)="onInputKeyDown($event,row,column,i)" 
                      (keyup)="onInputKeyup($event,row,column,i)" >
                  </mat-form-field> 
              </div>
              <!-- checkbox box TableRD_Type = 1 -->
              <div *ngIf="column.TableRD_Type==1">
                  <mat-checkbox [disabled]="getDisabled(row,column)" [name]="'input_'+column.TableRD_Champs" (change)="onCheckboxChange($event,row,column,i)" [(ngModel)]="row[column.TableRD_Champs]"></mat-checkbox>
              </div>
              
              <!-- ComboBox box TableRD_Type = 2 -->
              <div *ngIf="column.TableRD_Type==2">
                <mat-form-field     appearance="outline"   [ngStyle]="getStyleInput(column)">
                  <mat-select [name]="'select_'+column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]"  (selectionChange)="onSelectChange($event,row,column,i)">
                    <mat-option *ngFor="let select of column.dataSelect" [value]="getValueSelect(select,column)">
                      {{getTextSelect(select,column)}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- champs recherche TableRD_Type = 3 -->
              <div *ngIf="column.TableRD_Type==3">
                <app-recherche 
                  [numColonneToShow]="column.numColonneToShow"
                  [numColonneToReturn] = "column.numColonneToReturn"
                  [required]="column.required" 
                  [style]="column.style" 
                  [api]="api"
                  [recherche]="column.recherche"
                  [param]="column.param"
                  [name]="'input_'+column.TableRD_Champs"
                  [placeholder]="column.placeholder"
                  [row] = "row"
                  [column] = "column"
                  [indexRow] = "i"
                  (ChampBlur)="ChampBlur($event,row,column,i)" 
                  (ChampEnter)="ChampEnter($event,row,column,i)" ngModel
                  (KeyDown)="onInputKeyDown($event,row,column,i)" >
                </app-recherche>
              </div>
              <!-- date TableRD_Type = 4 -->
              <div *ngIf="column.TableRD_Type==4">
                  <mat-form-field     appearance="outline"   [ngStyle]="getStyleInput(column)">
                    <input matInput [name]="'input_'+column.TableRD_Champs"
                      [(ngModel)]="row[column.TableRD_Champs]" [matDatepicker]="picker1">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field> 
              </div>
              
              <!-- html TableRD_Type = 7 -->
              <div *ngIf="column.TableRD_Type==7"   [ngStyle]="getStyleInput(column)" [innerHTML]="row[column.TableRD_Champs]"></div>
              <!-- icon TableRD_Type = 8 -->
              <span *ngIf="column.TableRD_Type==8" style="cursor: pointer;" (click)="clickBtnTable(row,column.TableRD_Champs,i)" >
                <mat-icon color="primary">{{row[column.TableRD_Champs]}}</mat-icon>
              </span>
              <!-- time box TableRD_Type = 9 -->
              <div *ngIf="column.TableRD_Type==9"   [ngStyle]="getStyleInput(column)">
                <mat-form-field     appearance="outline"    [ngStyle]="getStyleInput(column)" >
                    <input (keydown)="onInputKeyDown($event,row,column,i)" (keyup)="onInputKeyup($event,row,column,i)"  type="time" matInput [name]="'input_'+column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]" >
                </mat-form-field>  
              </div>
              <!-- button TableRD_Type = 100 -->
              <div *ngIf="column.TableRD_Type== 100" class="button-row"  >
                  <button type="button" mat-raised-button color="primary" (click)="clickBtnTable(row,column.TableRD_Champs,i)" >
                      <mat-icon *ngIf="column.TableRD_Icon != null && column.TableRD_Icon != undefined && column.TableRD_Icon != ''">{{column.TableRD_Icon}}</mat-icon>
                      <span>{{row[column.TableRD_Champs] }}</span>
                  </button>
              </div>
              
              <!-- Link TableRD_Type = 101 -->
              <div *ngIf="column.TableRD_Type==101">
                  <a routerLink="{{column.href}}">{{row[column.TableRD_Champs] }} </a>           
              </div>  
              <!-- button tooltipe TableRD_Type = 102 -->
              <div *ngIf="column.TableRD_Type== 102" class="button-row"  >
                <button [matTooltip]="row[column.TableRD_Champs]" type="button" mat-raised-button [ngClass]="getClass(column)"  (click)="clickBtnTable(row,column.TableRD_Champs,i)" >
                    <mat-icon *ngIf="column.TableRD_Icon != null && column.TableRD_Icon != undefined && column.TableRD_Icon != ''">{{column.TableRD_Icon}}</mat-icon>
                    <span>{{column.TableRD_TooltipText}}</span>
                </button>
              </div>
              <!-- icon TableRD_Type = 103 -->
              <span *ngIf="column.TableRD_Type==103" [matTooltip]="row[column.TableRD_Champs]" style="cursor: pointer;" (click)="clickBtnTable(row,column.TableRD_Champs,i)" >
                <mat-icon [ngClass]="getClass(column)">{{column.TableRD_Icon}}</mat-icon>
              </span> 
              <!-- ComboBox aved dataSelectet differant celon row box TableRD_Type = 104 -->
              <div *ngIf="column.TableRD_Type==104">
                <mat-form-field     appearance="outline"   [ngStyle]="getStyleInput(column)">
                  <mat-select [name]="'select_'+column.TableRD_Champs" [(ngModel)]="row[column.TableRD_Champs]" (selectionChange)="onSelectChange($event,row,column,i)">
                    <mat-option *ngFor="let select of column.dataSelect[i]" [value]="select[column.valueSelect]">
                      {{select[column.textSelect] }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div> 
              <!-- auto compleat input text TableRD_Type = 105 -->
              <div *ngIf="column.TableRD_Type==105">
                <mat-form-field     appearance="outline"   [ngStyle]="getStyleInput(column)" >
                  <input [disabled]="getDisabled(row,column)" 
                  type="text" matInput [name]="'input_'+column.TableRD_Champs" 
                  [(ngModel)]="row[column.TableRD_Champs]"
                  [matAutocomplete]="auto1" 
                  (keydown)="onInputKeyDown($event,row,column,i)"
                  (keyup)="onInputKeyup($event,row,column,i)"
                  (blur)="onBlur($event,row,column,i)" 
                  (input)="onInput($event,row,column,i)">
                  <mat-autocomplete #auto1="matAutocomplete"
                  (optionSelected)="onSelectionAutocompleteChanged($event,row,column,i)">
                    <mat-option *ngFor="let option of column.dataToShow" [value]="option">
                      {{option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>  
              </div>
            </ng-template>
        </td>
         <!-- </ng-container> -->
        <td mat-footer-cell *matFooterCellDef [ngStyle]="getStyle(column)"><span *ngIf="column.TableRD_ExpressionH != null &&  column.TableRD_ExpressionH.toString().length > 0 " >{{column.TableRD_ExpressionH + " "}}{{getSomme(column)}}</span></td>
      </ng-container>
      <ng-container  *ngIf="displayedColumnsBrut.customFooter">
        <ng-container  *ngFor="let footer of displayedColumnsBrut.customFooter.listeFooter;let i = index">
          <ng-container *ngFor="let c of footer.colonne;let j = index" matColumnDef="{{'col-'+ i + '-' + j}}">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="c.colspan">
              <div [ngStyle]="c.style ? c.style : {}">
                {{c.text}}
              </div>
            </td>       
          </ng-container>

        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr [ngClass]="'rowClass'+randomNumber" mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="dblclickRow($event,row)" (click)="clickRow($event,row)">
      <tr  mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
      <ng-container *ngIf="displayedColumnsBrut.customFooter" >
        <ng-container *ngFor="let footer of displayedColumnsBrut.customFooter.listeFooter;let i = index">
          <tr mat-footer-row *matFooterRowDef="genererColonne(footer.colonne,i);sticky: true" ></tr>
        </ng-container>
      </ng-container>
    </table>        
  </div>
</div>